// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2056":"fc9207cd","6406":"fc9207cd"}[chunkId] + ".chunk.css";
};